module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-monroe.bc21cb4c.png";